// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AeGqStnmJhjdQBAatTxP {
    background-color: #f5f5f5;
    border-radius: 3px;
    border: 1px solid #ddd;
    padding: 0px 6px;
    margin-left: 4px;
    margin-right: 4px;
}

.ZrVlHu8_vkGDnR0QqiGW {
    background-color: #f2dede;
}

.zNkp2MZrbc_7H0Ff_x7K {
    background-color: #fcf8e3;
}

.yMWkZI_Uv8PyZC7f0LZ9 {
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/validations.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IAEI,yBAAyB;AAC7B;;AAEA;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".data {\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    border: 1px solid #ddd;\n    padding: 0px 6px;\n    margin-left: 4px;\n    margin-right: 4px;\n}\n\n.error {\n    composes: data;\n    background-color: #f2dede;\n}\n\n.warning {\n    composes: data;\n    background-color: #fcf8e3;\n}\n\n.blank {\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"data": `AeGqStnmJhjdQBAatTxP`,
	"error": `ZrVlHu8_vkGDnR0QqiGW AeGqStnmJhjdQBAatTxP`,
	"warning": `zNkp2MZrbc_7H0Ff_x7K AeGqStnmJhjdQBAatTxP`,
	"blank": `yMWkZI_Uv8PyZC7f0LZ9`
};
export default ___CSS_LOADER_EXPORT___;
